const M = [
  {
    name: "myDiscountCoupon",
    zh: "我的优惠券",
    en: "My discount coupon"
  },
  {
    name: "coupon",
    zh: "优惠券",
    en: "Coupon"
  },
  {
    name: "platformCoupon",
    zh: "平台券",
    en: "Platform coupon"
  },
  {
    name: "merchantCoupon",
    zh: "商家券",
    en: "Merchant coupon"
  },
  {
    name: "selectPlatformCoupon",
    zh: "选择平台券",
    en: "Select platform coupon"
  },
  {
    name: "selectMerchantCoupon",
    zh: "选择商家券",
    en: "Select merchant coupon"
  },
  {
    name: "unavailable",
    zh: "暂无可用",
    en: "Unavailable"
  },
  {
    name: "shopOffer",
    zh: "店铺优惠",
    en: "Shop offer"
  },
  {
    name: "cashback",
    zh: "满减",
    en: "Cashback"
  },
  {
    name: "cashbackActivity",
    zh: "满减活动",
    en: "Cashback activity"
  },
  {
    name: "goodsCashback",
    zh: "商品满减",
    en: "Goods cashback"
  },
  {
    name: "reduced",
    zh: "已减",
    en: "Reduced"
  },
  {
    name: "received",
    zh: "已领",
    en: "Received"
  },
  {
    name: "receive",
    zh: "领取",
    en: "Receive"
  },
  {
    name: "goUse",
    zh: "去使用",
    en: "Go to use"
  },
  {
    name: "unused",
    zh: "未使用",
    en: "Unused"
  },
  {
    name: "used",
    zh: "已使用",
    en: "Used"
  },
  {
    name: "expired",
    zh: "已过期",
    en: "Expired"
  },
  {
    name: "useImmediately",
    zh: "立即使用",
    en: "Use immediately"
  },
  {
    name: "getRightNow",
    zh: "立即领取",
    en: "Receive"
  },
  {
    name: "cashback",
    zh: "满减券",
    en: "Cashback"
  },
  {
    name: "voucher",
    zh: "代金券",
    en: "Voucher"
  },
  {
    name: "unlimited",
    zh: "无门槛",
    en: "Unlimited"
  },
  {
    name: "AboutToExpired",
    zh: "即将到期",
    en: "About to expired"
  },
  {
    name: "description",
    zh: "使用说明",
    en: "Description"
  },
  {
    name: "instruction",
    zh: "使用须知",
    en: "Instruction"
  },
  {
    name: "canSave",
    zh: "可节省",
    en: "Save"
  },
  {
    name: "upTo",
    zh: "满",
    en: "Up to "
  },
  {
    name: "available",
    zh: "可用",
    en: " available"
  },
  {
    name: "couponsAvailable",
    zh: "张可用",
    en: " coupons available"
  }
];

export default M;
